import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN ?? "";
const isEnabled = dsn.length > 0;

if (isEnabled) {
	Sentry.init({
		dsn,
		environment: import.meta.env.MODE,
		tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
		integrations: [
			Sentry.replayIntegration({
				maskAllText: true,
				maskAllInputs: true,
				blockAllMedia: true,
			}),
		],
	});
}

export { isEnabled as sentryEnabled };
export { Sentry };
